module.exports = __webpack_public_path__ + "static/img/guang.97a41d38.png";